import React from "react";
import PropTypes from "prop-types";

const IconBlockSection = ({section}) => {
  let { content, colour, bgColour, topMargin, bottomMargin, heading } = section;
  let blockCount = content.items.length;

  return (
    <div className={`wrapper block-wrapper plr-md-3 plr-lg-0 bg-${bgColour} ${topMargin} ${bottomMargin}`}>
      {heading && (
        <div className="wrapper--inner">
          <h2 
            className={`ff-s h2 block-heading mt-0 ta-center color-${colour}`}
            dangerouslySetInnerHTML={{__html: heading}}></h2>
        </div>
      )}
      
      <div className="wrapper--inner flex flex-w-w flex-jc-sb">
        {content.items.map((item, index) => {
          let content = item.content;
          let half = (blockCount > 2) && (blockCount == 4 || index != 0)
          return (
            <div
              key={item.id}
              className={`col-1 col-lg-${blockCount}-1 ${half ? 'col-md-2-1' : ''} ${colour == 'white' ? 'bg-grey' : 'bg-white'} cta-block icon-block`}
            >
              <div className="heading-section max-w-100 mla mra">
                <img alt={content.image_alt} src={content.image} srcSet={content.image_srcset} vspace="10" />
                <h3 className="h3 ff-ss" dangerouslySetInnerHTML={{__html: content.heading}}></h3>
              </div>
              <div className="max-w-100 mla mra" dangerouslySetInnerHTML={{__html: content.content}}></div>
              <a href={content.url} 
                className="mvh-0a btn-m-m btn-red" 
                target={content.url.includes('http') ? '_blank' : '_self'}
              >{content.button}</a>
            </div>
          );
        })}
      </div>
    </div>
  );
}

IconBlockSection.propTypes = {
  section: PropTypes.object.isRequired
}

export default IconBlockSection;
